module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_1.037d6b18.png";